import { render } from "./KnowledgeCoursesView.vue?vue&type=template&id=6638bd28&scoped=true"
import script from "./KnowledgeCoursesView.vue?vue&type=script&lang=js"
export * from "./KnowledgeCoursesView.vue?vue&type=script&lang=js"

import "./KnowledgeCoursesView.vue?vue&type=style&index=0&id=6638bd28&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6638bd28"]])

export default __exports__